import { c as _c } from "react/compiler-runtime";
import type { Document } from '@onefootprint/request-types/dashboard';
import type { BadgeProps } from '@onefootprint/ui';
import { Badge } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { DocumentStatus } from '../../utils/get-document-status';
type DocumentStatusBadgeProps = {
  document: Omit<Document, 'uploads'>;
  status: DocumentStatus;
};
const DocumentStatusBadge = t0 => {
  const $0 = _c(9);
  const {
    status
  } = t0;
  let t1;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.documents.status"
    };
    $0[0] = t1;
  } else {
    t1 = $0[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  if (!status) {
    return null;
  }
  const colorClass = DocStatusToVariant[status];
  let t2;
  if ($0[1] !== status) {
    t2 = $ => $[status];
    $0[1] = status;
    $0[2] = t2;
  } else {
    t2 = $0[2];
  }
  let t3;
  if ($0[3] !== t || $0[4] !== t2) {
    t3 = t(t2);
    $0[3] = t;
    $0[4] = t2;
    $0[5] = t3;
  } else {
    t3 = $0[5];
  }
  let t4;
  if ($0[6] !== colorClass || $0[7] !== t3) {
    t4 = <Badge variant={colorClass}>{t3}</Badge>;
    $0[6] = colorClass;
    $0[7] = t3;
    $0[8] = t4;
  } else {
    t4 = $0[8];
  }
  return t4;
};
const DocStatusToVariant: Record<DocumentStatus, BadgeProps['variant']> = {
  [DocumentStatus.UploadedViaApi]: 'neutral',
  [DocumentStatus.Uploaded]: 'neutral',
  [DocumentStatus.ReviewedByMachine]: 'neutral',
  [DocumentStatus.ReviewedByHuman]: 'neutral',
  [DocumentStatus.UploadAbandoned]: 'neutral',
  [DocumentStatus.UploadIncomplete]: 'warning',
  [DocumentStatus.PendingMachineReview]: 'error',
  [DocumentStatus.PendingHumanReview]: 'error',
  [DocumentStatus.UploadFailed]: 'error'
};
export default DocumentStatusBadge;